import { AppStateComponents, SETTINGS } from '../../../utils/constants';
import { FormView } from '../base/Form';
export class OrderView extends FormView {
    constructor(container, events) {
        super(container, events);
        this.events = events;
        this._card = container.elements.namedItem(SETTINGS.orderSettings.orderMethodPay.card);
        this._cash = container.elements.namedItem(SETTINGS.orderSettings.orderMethodPay.cash);
        this.addOnClickHandler(this._card, SETTINGS.orderSettings.orderMethodPay.card);
        this.addOnClickHandler(this._cash, SETTINGS.orderSettings.orderMethodPay.cash);
    }
    addOnClickHandler(button, name) {
        button.addEventListener('click', () => {
            [this._card, this._cash].forEach((btn) => btn.classList.remove(SETTINGS.orderSettings.orderMethodPay.active));
            button.classList.add(SETTINGS.orderSettings.orderMethodPay.active);
            this.onInputChange('payment', name);
        });
    }
    onInputChange(field, value) {
        this.events.emit(AppStateComponents.ORDER.INPUT, { field, value });
    }
    btnsInActive() {
        [this._cash, this._card].forEach((btn) => btn.classList.remove(SETTINGS.orderSettings.orderMethodPay.active));
    }
}
